import React from "react";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header, { HeaderNav, Menu } from "../../Components/Header/Header";
import Buttons from "../../Components/Button/Buttons";
import { Link as ScrollTo } from "react-scroll";
import AddFranchise from "../../Components/Modal/add-franchise";
import { m } from "framer-motion";
import { fadeIn, zoomIn } from "../../Functions/GlobalAnimations";
import { Parallax } from "react-scroll-parallax";
import {
  InfoBannerData03,
  InfoBannerData06,
} from "../../Components/InfoBanner/InfoBannerData";
import InfoBannerStyle03 from "../../Components/InfoBanner/InfoBannerStyle03";
import InfoBannerStyle06 from "../../Components/InfoBanner/InfoBannerStyle06";
// Data
import { blogData } from "../../Components/Blogs/BlogData";

const blogSimpleData = blogData.filter((item) => item.blogType === "simple");

export default function OurProduct(props) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div>
        {/* Header Start */}
        <Header
          topSpace={{ dekstop: false, md: true }}
          type="reverse-scroll"
          className="w-[calc(100%-80px)] left-10 top-[30px] bg-white/5 rounded-[40px] backdrop-blur-md"
        >
          <HeaderNav
            fluid="fluid"
            theme="dark"
            expand="lg"
            className="px-[35px] py-[0px] md:pr-[15px] sm:pr-0 md:pl-0 md:py-[14px]"
          >
            <Col lg={2} sm={6} className="col-auto me-auto ps-lg-0 sm:!pl-0">
              <Link
                aria-label="header home link"
                className="flex items-center"
                to="/"
              >
                <Navbar.Brand className="inline-block p-0 m-0">
                  <img
                    className="default-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-white@2x.webp"
                    alt="logo"
                  />
                  <img
                    className="alt-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-black@2x.webp"
                    alt="logo"
                  />
                  <img
                    className="mobile-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-black@2x.webp"
                    alt="logo"
                  />
                </Navbar.Brand>
              </Link>
            </Col>
            <Navbar.Toggle className="order-last md:ml-[25px] sm:ml-[17px]">
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </Navbar.Toggle>
            <Navbar.Collapse className="col-auto justify-center menu-order px-lg-0 restaurant-header-menu">
              <Menu {...props} />
            </Navbar.Collapse>
            <Col className="col-auto col-lg-2 text-right pe-0 font-size-0 ">
              <Buttons
                onClick={() => setOpen(true)}
                type="button"
                className="px-[20px] py-[10px] btn-fill font-medium font-serif rounded-[10px] uppercase md:mb-0 bg-gradient-to-r from-red-500 to-red-600 text-white"
                // themeColor="bg-gradient-to-r from-red-500 to-red-600"
                // color="white"
                size="sm"
                title="Be a Franchise"
              />
              {/* </ScrollTo> */}
            </Col>
          </HeaderNav>
        </Header>
        {/* Header End */}

        {/* Parallax Scrolling Start */}
        <div className="h-[660px] lg:h-[580px] md:h-[550px] sm:h-[500px] xs:h-[380px] overflow-hidden relative">
          <Parallax
            className="lg-no-parallax h-[100vh] w-full bg-cover bg-top cover-background absolute top-[0px] left-0 lg:h-[700px] lg:-top-[100px] md:h-[650px] sm:h-[550px] xs:h-[420px] xs:-top-[70px]"
            translateY={[-40, 40]}
            style={{
              backgroundImage: `url(https://res.cloudinary.com/duk4olh1p/image/upload/v1758806973/banner4_cymnqv.webp)`,
            }}
          ></Parallax>
          <div className="absolute h-full w-full opacity-50 top-0 left-0 bg-darkgray"></div>
          <Container className="h-full relative xs:px-[15px]">
            <Row className="justify-center h-full">
              <Col
                xl={6}
                lg={7}
                md={8}
                className="relative font-serif text-center text-white flex justify-center flex-col"
              >
                <h1 className="opacity-60 mb-[20px] text-xmd leading-[20px]">
                  Your Daily Chai Fix
                </h1>
                <h2 className="font-medium -tracking-[1px] mb-0">
                  Authentic taste <br /> Every time
                </h2>
              </Col>
              <ScrollTo
                to="about"
                offset={0}
                delay={0}
                spy={true}
                smooth={true}
                duration={800}
                className="absolute bottom-[50px] left-1/2 w-auto inline-block -translate-x-1/2 cursor-pointer"
              >
                <i className="ti-arrow-down text-lg leading-none text-white bg-[rgba(0,0,0,0.7)] p-[15px] xs:p-[10px] rounded-full flex justify-center items-center"></i>
              </ScrollTo>
            </Row>
          </Container>
        </div>
        {/* Parallax Scrolling End */}

        {/* product showcase  */}

        <Container>
          <m.div {...fadeIn} className="justify-center row mt-5">
            <Col
              lg={4}
              md={6}
              className="text-center mb-[4.5rem] md:mb-16 sm:mb-12"
            >
              <div className="flex flex-row items-center justify-center text-center mb-[5px]">
                <span className="w-[25px] h-[1px] bg-[#ea1d24] opacity-40"></span>
                <div className="font-serif text-xmd text-[#ea1d24] px-[10px]">
                  Our Specialties
                </div>
                <span className="w-[25px] h-[1px] bg-[#ea1d24] opacity-40"></span>
              </div>
              <h2 className="heading-5 font-serif font-semibold text-darkgray uppercase -tracking-[1px] sm:mb-[15px]">
                OUR Products
              </h2>
            </Col>
          </m.div>
          <InfoBannerStyle03
            grid="row-cols-1 row-cols-lg-3 row-cols-sm-2 gap-y-10 justify-center"
            className=""
            data={InfoBannerData06}
            animation={fadeIn}
          />
        </Container>
        {/* End of product showcase  */}

        {/* Section Start */}
        <section className="py-[160px] overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px]">
          <Container>
            <Row lg={4} sm={2} xs={1}>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  H.O Address
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  J.M Road, Near Gruenanak School Bhandup (W), Mumbai 78
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  C.O Address
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  Mukhiya Ji Chai, Jari Mari Kurla (W), Mumbai 400072
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  Sales Office
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  Mohalla Afghanan, Near Peer ki Chungi, Dhampur Road Nehtaur,
                  Distt- Bijnor (U.P) 246733
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.4 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-phone-call text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  Let's Talk
                </div>
                <p className="w-[70%] lg:w-full mx-auto">+91 7300863123</p>
                <p className="w-[70%] lg:w-full mx-auto">+91 9359059640</p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.6 } }}
                className="text-center xs:mb-[40px]"
              >
                <i className="feather-mail text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px] sm:mb-0">
                  General Support
                </div>
                <p className="w-[70%] lg:w-full mx-auto">
                  <a
                    aria-label="gmail link"
                    rel="noreferrer"
                    href="mailto:info@mukhiyajichai.com"
                    className="hover:text-[#ea1d24]"
                  >
                    mukhiyajichai@gmail.com
                  </a>
                  {/* <br />
                <a
                  aria-label="gmail link"
                  rel="noreferrer"
                  href="mailto:hr@yourdomain.com"
                  className="hover:text-[#ea1d24]"
                >
                  support@mukhiyajichai.com
                </a> */}
                </p>
              </m.div>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <section className="overflow-visible relative py-0">
          <ScrollTo
            href="#"
            to="parallax-section"
            offset={0}
            delay={0}
            spy={true}
            smooth={true}
            duration={800}
            className="left-1/2 top-1/2 absolute -translate-x-1/2 z-[1] -translate-y-1/2 cursor-pointer"
          >
            <m.img
              {...{ ...zoomIn, transition: { duration: 0.8 } }}
              width={198}
              height={197}
              className="w-[auto] md:w-[150px] sm:w-[100px]"
              src="https://lithoreact.themezaa.com/assets/img/webp/home-restaurant-img-transparent-07.webp"
              // src="/assets/img/banner/logo-wt.png"
              alt="restaurant"
            />
          </ScrollTo>
        </section>
        {/* Section Start */}

        {/* Footer Start */}
        <footer className="text-[#828282] py-[60px] border-t border-mediumgray md:pt-[80px] md:pb-[60px]">
          <Container>
            <Row className="items-center">
              <Col md={6} className="sm:mb-[15px]">
                <ul className="flex text-sm font-serif text-center justify-start md:justify-start sm:justify-center xs:text-center xs:flex-col">
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="about link"
                      to="/about-us"
                      className="hover:text-[#ea1d24]"
                    >
                      ABOUT US
                    </Link>
                  </li>
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="menu link"
                      to="/franchise"
                      className="hover:text-[#ea1d24]"
                    >
                      FRANCHISE
                    </Link>
                  </li>
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="gallery link"
                      to="/products"
                      className="hover:text-[#ea1d24]"
                    >
                      OUR PRODUCTS
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      aria-label="contact link"
                      to="/contact-us"
                      className="hover:text-[#ea1d24]"
                    >
                      CONTACT
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col md={6} className="text-right sm:text-center">
                <p className="text-sm uppercase flex items-center justify-end sm:justify-center">
                  © {new Date().getFullYear()} Mukhiya Ji Chai is Developed
                  by&nbsp;
                  <Buttons
                    target="_blank"
                    href="https://www.fluxteck.com/"
                    aria-label="button"
                    className="font-semibold p-0 font-serif text-decoration-line-bottom uppercase btn-link md:text-md hover:text-[#828282] !text-sm landscape:md:!leading-[18px]"
                    color="#000"
                    title="FluxTeck"
                  />
                </p>
              </Col>
            </Row>
          </Container>
        </footer>
        {/* Footer End */}
      </div>
      <AddFranchise open={open} setOpen={setOpen} />
    </>
  );
}
